import { render, staticRenderFns } from "./authority_management.vue?vue&type=template&id=642a9b10"
import script from "./authority_management.vue?vue&type=script&lang=js"
export * from "./authority_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports